<template>
  <modal
      id="renew-subscription-modal"
      size="large"
      v-model="showModal"
      :title="'Renew Subscription Package'"
      @submit="submit"
      :loading="loading"
      :btn-label="extendPackage ? $t('save') : $t('add')"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || extendPackage) && !preloader"
        ref="form"
        :data-url='extendPackage'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="select"
              :label="$t('package')"
              :placeholder="$placeholder('package')"
              v-model="formData.subscription_package"
              :list="subscription_packages"
              :required="true"
              :error-message="$errorMessage(errors, 'subscription_package')"
          />
        </div>
        <div class="col-md-12">
          <div class="row d-flex flex-row align-items-end">
            <div class="col-md-8">
              <app-form-group
                  :label="$t('promo_code (optional)')"
                  :placeholder="$placeholder('promo_code')"
                  v-model="formData.promo_code"
                  :required="true"
                  :error-message="$errorMessage(errors, 'promo_code')"
              />
            </div>
            <div class="col-md-4 form-group">
              <button type="button"
                      class="btn btn-primary" @click="validatePromoCode()">
                {{ $t('validate') }}
              </button>
            </div>
            <span class="text-success ml-4 d-none promoCodeValidated">{{ successMessage }}</span>
            <span class="text-danger ml-4 d-none promoCodeNotValidated">{{ errorMessage }}</span>
          </div>
        </div>

      </div>

    </form>

    <template v-if="!isMailSettingExist && !extendPackage" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
      >
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  EXTEND_PACKAGE,
  GET_ALL_PACKAGES,
  GET_TENANT_ACTIVE_SUBSCRIPTION,
  GET_TENANT_PACKAGES,
  TENANTS,
  VALIDATE_PROMO_CODE,
} from "../../../Config/ApiUrl";
import {TENANT_MAIL_CHECK_URL,} from "../../../../common/Config/apiUrl";
import {axiosGet, axiosPatch, axiosPost} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";

export default {
  name: "RenewSubscriptionModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin],
  props: {
    from: {
      type: String,
      default: 'package'
    },
    package: {
      type: Object,
    },
    subPackage: {
      type: Object,
      default: null
    },
    loaderColor: {
      type: String,
      default: 'white-color'
    },
    extendPackage: {
      type: String,
      default: null
    }
  },
  data() {
    this.fetchPackages();
    return {
      maps: null,
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      subscription_packages: [],
      // features: [],
      billingOptions: [
        { id: 'monthly', label: 'Monthly' },
        { id: 'yearly', label: 'Yearly' }
      ],
      // default_modules: ["job_desk","employee","attendance","leave","administration","payroll","location","asset"],
      moduleList: [
        // {label: 'Job Desk', id: 'job_desk'},
        {label: 'Employee', id: 'employee'},
        {label: 'Location', id: 'location'},
        {label: 'Attendance', id: 'attendance'},
        {label: 'Leave', id: 'leave'},
        {label: 'Administration', id: 'administration'},
        {label: 'Assets', id: 'assets'},
      ],
      formData: {
        promo_code: "",
        subscription_package: null,
      },
      tenant: null,
      newExpirationDate: '',
      errorMessage: '',
      successMessage: '',
      GET_ALL_PACKAGES,
      EXTEND_PACKAGE,
      VALIDATE_PROMO_CODE,
      TENANTS,
    }
  },
  methods: {
    async subscriptionPackages() {
      const packagesData = await axiosGet('selectable/packages').then((data) => {
        return data;
      });

      return packagesData.data.map(pkg => ({
        id: pkg.id,
        value: `${pkg.name} (${pkg.billing_cycle})`
      }));
    },
    validatePromoCode() {
      if (this.formData.promo_code !== "") {
        let code = {
          code: this.formData.promo_code
        };
        const response = axiosPost(VALIDATE_PROMO_CODE, code).then((res) => {
          const data = res.data;
          this.tenant = data.data.tenant;
          if (data.success) {
            let days_extension = data.data.days_extension; // 30, promo code reward
            this.newExpirationDate = days_extension; // setting global variable to pass to the API
            let expires_at = data.data.expires_at; // 2025-08-15 00:00:00, promo code expiry date

            let promoExpireDate = new Date(expires_at);
            let currentDate = new Date(); // Fri Jul 18 2025 02:30:57 GMT+0500 (Pakistan Standard Time)

            if (promoExpireDate > currentDate) {
              // expires_at is already passed, so extend tenant.ends_at

              this.newExpirationDate = days_extension; //tenantEndsAt.toISOString(); // format as YYYY-MM-DD or as needed
            } else {
              // expires_at is valid, no need to extend
              this.newExpirationDate = expires_at;
            }

            // show success span with class promoCodeValidated
            this.successMessage = data.message;
            document.getElementsByClassName('promoCodeValidated')[0].classList.remove('d-none');
            document.getElementsByClassName('promoCodeNotValidated')[0].classList.add('d-none');
          } else if (!data.success) {
            this.errorMessage = data.message;
            document.getElementsByClassName('promoCodeNotValidated')[0].classList.remove('d-none');
            document.getElementsByClassName('promoCodeValidated')[0].classList.add('d-none');
          }
        })
            .catch((error) => {
              const data = error.response.data;
              if (!data.success) {
                this.errorMessage = data.message;
                document.getElementsByClassName('promoCodeNotValidated')[0].classList.remove('d-none');
                document.getElementsByClassName('promoCodeValidated')[0].classList.add('d-none');
              }
            });

        return this.newExpirationDate;
      }

      return "";
    },
    switchPackage(_package) {

      axiosPatch(`${TENANTS}/${this.tenant_id}/switch-package`, {_package, new_expiration_date: this.newExpirationDate})
          .then(({ data }) => {
            this.confirmationModalActive = false;
            this.toastAndReload(data.message, 'package-management-table');
            this.fetchPackages();
          })
          .catch((error) => {
            // Check if the error response exists and has a message
            if (error.response && error.response.data) {
              const errorMessage = error.response.data.message || 'An error occurred. Please try again.';
              this.toastAndReload(errorMessage, 'package-management-table');
            } else {
              // Handle unexpected errors
              this.toastAndReload('An unexpected error occurred. Please try again.', 'package-management-table');
            }
            this.confirmationModalActive = false;
          })
          .finally(() => {
          });
    },
    fetchPackages() {
      axiosGet(GET_ALL_PACKAGES)
          .then(response => {
            // setting first package in dropdown
            if (response.data.data.length) {
              this.formData.subscription_package = response.data.data[response.data.data.length - 1]?.id ?? '';
            }
            this.monthlyPackages = response.data.data.filter((d) => d.billing_cycle === 'monthly');
            this.yearlyPackages = response.data.data.filter((d) => d.billing_cycle === 'yearly');
          });
      axiosGet(GET_TENANT_PACKAGES)
          .then(response => {
            // this.monthlyPackages = response.data.data.filter((d) => d.billing_cycle === 'monthly');
            // this.yearlyPackages = response.data.data.filter((d) => d.billing_cycle === 'yearly');
            this.tenant_id = response.data.data[0].tenant_id;
          });
      axiosGet(GET_TENANT_ACTIVE_SUBSCRIPTION)
          .then(response => {
            this.active_sub = response.data;
          });
    },
    submit() {
      this.$emit('switch-package', {_package: this.formData.subscription_package, duration_in_days: this.newExpirationDate});
      $('#renew-subscription-modal').modal('hide');

      this.fieldStatus.isSubmit = true;

      this.loading = true;
      this.message = '';
      this.errors = {};
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#package-list-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'package' ? 'package-table' : 'user-table');
      if (this.from === 'user') {
        this.$hub.$emit(`reload-role-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {

      this.formData = {
        ...this.formData,
        ...data,

      };

    },
    checkMailSettings() {
      this.preloader = true;
      axiosGet(TENANT_MAIL_CHECK_URL).then(response => {
        this.isMailSettingExist = !!response.data;
      }).finally(() => {
        this.preloader = false;
      });
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.extendPackage ? 'edit' : 'add', subject, true);
    },
  },
  async created() {
    this.subscription_packages = await this.subscriptionPackages();
    console.log("extendPackage", this.extendPackage);
    if (this.extendPackage) {
    }
    else {
    }
  },
  watch: {},
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  mounted() {
    this.formData.subscription_package = this.package;
  },
}
</script>